import { render } from "./MatrixType.vue?vue&type=template&id=5e4e464d"
import script from "./MatrixType.vue?vue&type=script&lang=js"
export * from "./MatrixType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__